var styles = {"box":"LiveLoad_box_1mfzb_1","vertical":"LiveLoad_vertical_1mfzb_10","gradient":"LiveLoad_gradient_1mfzb_15","visible":"LiveLoad_visible_1mfzb_25"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
